import { styled } from '@mui/material/styles';
import { lightBlue, deepPurple, teal, amber } from '@mui/material/colors';
import {
  Card,
  Button,Box
} from '@mui/material';



// Custom styled components for modern look
export const ModernCard = styled(Card)(({ theme }) => ({
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.05)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 40px rgba(0,0,0,0.1)'
  }
}));

export const PrimaryButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  padding: '10px 24px',
  textTransform: 'none',
  fontWeight: 600,
  background: `linear-gradient(135deg, ${lightBlue[500]}, ${teal[500]})`,
  color: theme.palette.common.white
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  padding: '10px 24px',
  textTransform: 'none',
  fontWeight: 600,
  border: `2px solid ${theme.palette.divider}`,
  '&:hover': {
    border: `2px solid ${lightBlue[500]}`
  }
}));
